import React from 'react';
import PictureEditor from '../../../../businessLogic/pictureEditor';

export default function CenterPanelUpdate(props) {
  return (
    <span>
      <div className="ui form">
        <div className="logoTitleColumn">
          <div className="bold center-text-on-tablet-ress center-text-on-small-ress">
            {APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoTitle}
          </div>
          <div>
            <div className="mrbs" />
            <PictureEditor
              ref={props.imageLogoRef}
              readOnly={props.readOnly}
              width={360}
              height={110}
              minimumScaleImage={0.2}
              applyDefaultImageStyle={false}
              pictureEditorClass={'waOrgLogoShell logoMiddleAlign waLogo'}
              border={10}
              imageUrl={props.waitingAreaLogoPauseImageForm.logoUrl}
              showAsDefaultImage={props.waitingAreaLogoPauseImageForm.orgLogoUrl ? false : true}
              defaultImageUrl={
                props.waitingAreaLogoPauseImageForm.orgLogoUrl
                  ? props.waitingAreaLogoPauseImageForm.orgLogoUrl
                  : props.waitingAreaLogoPauseImageForm.defaultSystemLogoUrl
              }
              color={[128, 128, 128, 0.7]}
            />
          </div>
          <div className="center-text-on-small-ress mrts logoMiddleAlign centerAlignDescription">
            <label className="placeholder-label   no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescription}
              <div className="inline-flex">
                <li />
                <div>{APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescription2}</div>
              </div>
              <div className="inline-flex">
                <li />
                <div>{APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescription3}</div>
              </div>
              <div className="inline-flex">
                <li />
                <div>{APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescription4}</div>
              </div>
            </label>
          </div>
          <div
            data-show={!props.readOnly}
            className="mrtxs  center-text-on-small-ress logoMiddleAlign centerAlignDescription"
          >
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescriptionPartTwo}
            </label>
          </div>
          <div data-show={!props.readOnly} className="center-text-on-small-ress logoMiddleAlign centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.LogoDescriptionPartThree}
            </label>
          </div>
          <div className="mrbs" />
        </div>
        <div className="mrtml show-on-tablet-ress " />
        <div className="mrtml show-on-small-ress " />

        <div className="PauseTitleColumn">
          <div className=" bold center-text-on-tablet-ress   center-text-on-small-ress">
            {APP.LANGUAGE.WaitingAreaLogoPauseImage.PauseTitle}
          </div>
          <div>
            <div className="mrbs" />
            <PictureEditor
              ref={props.imagePauseRef}
              readOnly={props.readOnly}
              width={800}
              height={600}
              showAsDefaultImage={false}
              imageUrl={props.waitingAreaLogoPauseImageForm.cameraUrl}
              fourByThreeRatio={true}
              defaultImageUrl={props.waitingAreaLogoPauseImageForm.defaultCameraUrl}
            />
          </div>
          <div className="center-text-on-small-ress logoMiddleAlign  mrts centerAlignDescription">
            <label className="placeholder-label   no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.PauseDescription}
            </label>
          </div>
          <div
            data-show={!props.readOnly}
            className="mrtxs logoMiddleAlign center-text-on-small-ress centerAlignDescription"
          >
            <label className="placeholder-label color-info-mid-grey-desktop logoMiddleAlign no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.PauseDescriptionPartTwo}
            </label>
          </div>
          <div data-show={!props.readOnly} className="center-text-on-small-ress logoMiddleAlign centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaLogoPauseImage.PauseDescriptionPartThree}
            </label>
          </div>
        </div>
        <div className="clear-both" />
      </div>
      <div data-show={!props.readOnly} className="mrbxl hide-on-small-ress" />
    </span>
  );
}
